import { IRootScopeService } from '@angular/upgrade/static/src/common/angular1';
import { IController, ILocationService } from 'angular';

export class SdcRootCtrl implements IController {
  static $inject: string[] = ['$location', '$rootScope'];

  public viewFullScreenGrid: boolean;

  constructor(private $location: ILocationService, private $rootScope: IRootScopeService) {}

  $onInit() {
    const url = this.$location.url();
    // when going directly to an sdc activity via the url (CM)
    this.viewFullScreenGrid = this.shouldShowFullScreenGrid(url);

    this.$rootScope.$on('$stateChangeSuccess', (event, toState) => {
      // when transitioning between sdc activities (CM)
      const stateName = toState.name;
      this.viewFullScreenGrid = this.shouldShowFullScreenGrid(stateName);
    });
  }

  shouldShowFullScreenGrid(stateNameOrUrl: string): boolean {
    const hideSideNav = stateNameOrUrl.includes('grid');

    return hideSideNav;
  }
}
